import { createContext } from "react";
import { IUser } from "../interfaces/services";

const userContext = createContext<IUser | undefined>(undefined)

export default userContext